import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './redux/store'
import { createTheme, ThemeProvider, PaletteColorOptions } from '@mui/material';
import App from 'App';
import ErrorBoundary from './errors/ErrorBoundary';
declare module '@mui/material/styles' {
  interface CustomPalette {
    primary: PaletteColorOptions;
    secondary: PaletteColorOptions;
    error: PaletteColorOptions;
  }
  interface Palette extends CustomPalette { }
  interface PaletteOptions extends CustomPalette { }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    primary: true;
    secondary: true;
    error: true;
  }
}

const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor, contrastText?) => augmentColor({ color: { main: mainColor, contrastText } });

let theme = createTheme({
  typography: {
    fontFamily: 'Libre Franklin',
    fontSize: 12,
    h6: {
      fontSize: 16,
      fontWeight: 600,
      color: '#003883',
    },
    h5: {
      fontSize: 18,
      fontWeight: 600,
      color: '#003883',
    },
    subtitle1: {
      fontSize: 12,
    },
    button: {
      textTransform: 'capitalize'
    },
  }
});

theme = createTheme(theme, {
  palette: {
    primary: createColor('#EE7D11', '#FFFFFF'),
    secondary: createColor('#003883', '#FFFFFF'),
    error: createColor('#d32f2f', '#FFFFFF')
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          }
        },
        contained: {
          borderRadius: 30,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          }
        },
        outlined: {
          borderRadius: 30,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          }
        },
        text: {
          borderRadius: 30,
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#003883',
          textDecorationColor: '#003883',
          '&:hover': {
            color: '#002861',
            textDecorationColor: '#002861',
          }
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          '&[role="menu"]': {
            color: '#003883'
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        row: {
          "&.Mui-selected": {
            backgroundColor: "#00388324",
            "&:hover": {
              backgroundColor: "#00388324"
            }
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root, & .MuiInputLabel-root": {
            fontSize: 12
          },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
              borderColor: '#003883',
            }
          },
          "& .MuiInputLabel-root": {
            "&.Mui-focused": {
              color: '#003883',
            }
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: '#003883',
          }
        }
      }
    }
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <App />
        </Provider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();